import { palette, typography, breakpoints, spacing } from './definitions'
import { createTheme } from '@mui/material/styles'
import { alpha } from '@mui/material/styles'
import Divider from './components/Divider'
import CssBaseline from './components/CssBaseline'

export default createTheme({
  palette,
  typography,
  breakpoints,
  spacing,
  components: {
    MuiPaper: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: {
          border: `1px solid ${palette.common.outline}`,
          borderRadius: 12,
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.04)',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: palette.common.outline,
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(0, 0, 0, 0.2)',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: palette.primary.main,
            borderWidth: 2,
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontSize: 14,
          maxHeight: '2.5rem',
          color: palette.common.white,
          fontWeight: 500,
          fontFamily: typography.fontFamily,
          textTransform: 'none',
        },
      },
      variants: [
        {
          props: { variant: 'outlined', color: 'secondary' },
          style: {
            border: `1px solid ${palette.common.outline}`,
            color: alpha(palette.text.main, 0.8),
            fontWeight: 400,
            lineHeight: '1.25rem',
          },
        },
        {
          props: { variant: 'outlined', color: 'primary' },
          style: {
            '&:hover': {
              backgroundColor: alpha(palette.primary.main, 0.06),
            },
            '& .MuiButton-startIcon': {
              mr: 1.5,
            },
          },
        },
      ],
    },
    MuiCssBaseline: CssBaseline,
    MuiDivider: Divider,
  },
})
